import React from "react";
import banner1 from "../../assets/images/banner-shape1.webp";
import banner2 from "../../assets/images/banner-shape2.webp";
import { Link } from "react-router-dom";

const BredCrumb = ({ Title, subtitle }) => {
  return (
    <>
      {/* <div className="bred_crumb">
       
      </div> */}
      <section className="banner_section" id="home_sec">
        <div className="judul-content">
          <div className="blure_shape bs_1"> </div>
          {/* <div className="blure_shape bs_2"> </div> */}
          <div
            className="container"
            style={{
              flex: 1,
              width: "100vw",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="bred_text" style={{ color: `var(--primery)` }}>
              <h1>{Title}</h1>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default BredCrumb;
